module.exports = __webpack_public_path__ + "static/media/logo.77186d6a.svg";